import { useUsersStore } from "../stores/users.store";
import { useGlobalsStore } from "../stores/globals.store";
import { useBotsStore } from "../stores/bots.store";
import { useState } from "react";
import { Bot } from "../types/bot.type";
import { randomizeIcon } from "../utils/botUtils";

export function useActiveBot() {
  const profile = useUsersStore(state => state.user);
  const defaultBot = useGlobalsStore(state => state?.globals?.defaultBotConfig);
  const userBot = useBotsStore(state =>
    state.bots.find(b => b.user === profile?.userId)
  );
  const [activeBot] = useState<Bot>(
    userBot ?? {
      ...defaultBot,
      img: randomizeIcon(),
      mode: "backtest"
    }
  );
  return { activeBot, userBot, profile };
}
